import { render, staticRenderFns } from "./TheCommentModal.vue?vue&type=template&id=85c43eae"
import script from "./TheCommentModal.vue?vue&type=script&lang=js"
export * from "./TheCommentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports